/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-31
 */


import { LangChangeEvent} from "@ngx-translate/core/lib/translate.service";
import { ProgressData, ProgressService } from "src/refresh/service/progress-service";
import { Progress,Path } from  "../_common/constant/page-const";

export class ProgressSet {

       public set(url:string, progress: ProgressService ) {

              url = url.substring(1);
            
              if ( url == Path.Setup1 ) {
                   progress.setIndex(Progress.Eligibility); 
                   progress.setMenu(Progress.Eligibility); return;
              }               
              else
              if ( url == Path.AboutTheChildMain ) {
                   progress.setIndex(Progress.AboutChild); 
                   progress.setMenu(Progress.AboutChild); return;
              }               
              else
              if ( url == Path.AboutTheParentsMain ) {
                   progress.setIndex(Progress.AboutParent); 
                   progress.setMenu(Progress.AboutParent); return;
              }               
              else
              if ( url == Path.FinalReview ) {
                   progress.setIndex(Progress.Review); 
                   progress.setMenu(Progress.Review); return;
              }               
              else
              if ( url == Path.BirthCertificate  ) {
                   progress.setMenu(Progress.OrderBC);
                   progress.setIndex(Progress.OrderBC); return;
              }               
              else
              if ( url == Path.CCBMain ) {
                   progress.setMenu(Progress.CCB);
                   progress.setIndex(Progress.CCB); return;
              }               
              else
              if ( url == Path.SINMain ) {
                   progress.setMenu(Progress.SIN);
                   progress.setIndex(Progress.SIN); return;
              }               
              else
              if ( url == Path.ESRMain ) {
                   progress.setMenu(Progress.ESR);
                   progress.setIndex(Progress.ESR); return;
              }               
              //======================================================================================
              else
              if ( url == Path.Transition1 ) {
                   progress.setIndex(Progress.Review); return; 
              }               
              else
              if ( url == Path.OrderSummary ) {
                   progress.setIndex(Progress.Summary ); return;
              }               
              else
              if ( url == Path.ESRAreYouSure ) {
                   progress.setIndex(Progress.ESR ); return;
              }               
              else
              if ( url == Path.SINAreYouSure ) {
                   progress.setIndex(Progress.SIN ); return;
              }               
              else
              if ( url == Path.CCBAreYouSure ) {
                   progress.setIndex(Progress.CCB ); return;
              }               
              else
              if ( url == Path.Transition2 ) {
                   progress.setIndex(Progress.OrderBC ); return;
              }   
              else
              if ( url == Path.Start ) {
                   progress.setIndex(Progress.Start); return;
              }   
      }

      public init(event: LangChangeEvent, progress: ProgressService) {
            
            let progressNameMap:Map<number,string> = progress.progressNameMap;
            let name = event.translations.progress;

            progressNameMap.set(Progress.Start,name.birthReg);
            progressNameMap.set(Progress.Eligibility,name.birthReg);
            progressNameMap.set(Progress.AboutChild,name.birthReg);
            progressNameMap.set(Progress.AboutParent,name.birthReg);
            progressNameMap.set(Progress.Review,name.birthReg);

            progressNameMap.set(Progress.OrderBC,name.orderBC);
            progressNameMap.set(Progress.CCB,name.CCB);
            progressNameMap.set(Progress.SIN,name.SIN);
            progressNameMap.set(Progress.ESR,name.ESR);
            progressNameMap.set(Progress.Summary,name.summary);

            let progressMenuMap:Array<ProgressData> = progress.progressMenuMap;
            let menu = event.translations.menu;

            progressMenuMap[0] = null;
            progressMenuMap[Progress.Start] =       new ProgressData(menu.start, menu.alt_start);
            progressMenuMap[Progress.Eligibility] = new ProgressData(menu.eligibility,menu.alt_eligibility);
            progressMenuMap[Progress.AboutChild] =  new ProgressData(menu.about_the_child,menu.alt_about_the_child);
            progressMenuMap[Progress.AboutParent] = new ProgressData(menu.about_the_parents,menu.alt_about_the_parents);
            progressMenuMap[Progress.Review] =      new ProgressData(menu.review,menu.alt_review);
            progressMenuMap[Progress.OrderBC] =     new ProgressData(menu.orderBC,menu.alt_orderBC);
            progressMenuMap[Progress.CCB] =         new ProgressData(menu.CCB,menu.alt_CCB);
            progressMenuMap[Progress.SIN] =         new ProgressData(menu.SIN,menu.alt_SIN);
            progressMenuMap[Progress.ESR] =         new ProgressData(menu.ESR,menu.alt_ESR);
            progressMenuMap[Progress.Receipt] =     new ProgressData(menu.Receipt,menu.alt_Receipt);

            progress.CCBData = progressMenuMap[Progress.CCB];
            progress.SINData = progressMenuMap[Progress.SIN];
            progress.BCData  = progressMenuMap[Progress.OrderBC];

            progress.init(1);
      } 

      public setIndexValue(progress: ProgressService) {
             let progressIndex = progress.progressIndex;
             progressIndex[Progress.Start] = 0;   

             progressIndex[Progress.Eligibility] = 10;   
             progressIndex[Progress.AboutChild] = 20;   
             progressIndex[Progress.AboutParent] = 30;   
             progressIndex[Progress.Review] = 40;  

             progressIndex[Progress.OrderBC] = 50;    
             progressIndex[Progress.CCB] = 60;        
             progressIndex[Progress.SIN] = 70;        
             progressIndex[Progress.ESR] = 80;        
             progressIndex[Progress.Summary] = 90;    
       }
}

//Progress.Eligibility 
